import { Card } from "@amzn/stencil-react-components/card";
import { Checkbox } from "@amzn/stencil-react-components/checkbox";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { MessageBanner } from "@amzn/stencil-react-components/message-banner";
import { Label, Text } from "@amzn/stencil-react-components/text";
import { getString } from "common/uistringlabels/uiStringUtils";
import { AmazonianInformation } from "lib/models/oui-models";
import React, { FC } from "react";
import { useChangeAddressFormActions, useChangeAddressFormItems } from "view/Page/CheckoutPage/useChangeAddressForm";
import { useCheckoutFormActions, useCheckoutFormItems } from "view/Page/CheckoutPage/useCheckoutForm";

import ChangeShippingDetails from "../ChangeShippingAddressFields";
import { FormField } from "./Helpers";

export interface ChangeShippingDetailsCardProps {
  isLoadingUserInfo: boolean;
  userInfo: AmazonianInformation | undefined;
  checkoutItems: useCheckoutFormItems;
  checkoutActions: useCheckoutFormActions;
  addressItems: useChangeAddressFormItems;
  addressActions: useChangeAddressFormActions;
}

const stringPath = "checkout.formPanel.shippingDetailsCard";

const ChangeShippingDetailsCard: FC<ChangeShippingDetailsCardProps> = (props: ChangeShippingDetailsCardProps) => {
  return (
    <Card data-testid="shipping-details-card" padding="S300" width="100%">
      <Col gridGap="S300" width="100%">
        <Col>
          <Text fontSize="T400" fontWeight="bold" color="neutral90">
            {getString(`${stringPath}.step2`)}
          </Text>
          <Text fontSize="T200" color="neutral90">
            {getString(`${stringPath}.description`)}
          </Text>
        </Col>

        <Col gridGap={"S200"} width="85%">
          <ChangeShippingDetails addressItems={props.addressItems} addressActions={props.addressActions} />
          <MessageBanner>{getString(`${stringPath}.banner`)}</MessageBanner>
        </Col>

        <FormField
          testId="delivery-instructions-input"
          label={getString(`${stringPath}.deliveryInstructions`)}
          value={props.checkoutItems.formValues.deliveryInstructions}
          onChange={(value) => props.checkoutActions.handleInputChange("deliveryInstructions", value)}
          placeholder={getString(`${stringPath}.placeholderDeliveryInstructions`)}
          isTextArea
        />

        <Row gridGap="S200">
          <Checkbox
            checked={props.checkoutItems.formValues.shippingDetailsConfirmationCheckbox}
            data-testid="address-confirmation-checkbox"
            onChange={(event) =>
              props.checkoutActions.handleInputChange("shippingDetailsConfirmationCheckbox", event.target.checked)
            }
          />
          <Label>{getString(`${stringPath}.shippingDetailsConfirmation`)}</Label>
        </Row>
      </Col>
    </Card>
  );
};

export default ChangeShippingDetailsCard;
